// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pie-chart-skeleton{display:flex}@media(max-width:1279px){.pie-chart-skeleton{margin-top:50px}}.pie-chart-skeleton-body{flex:0 0 250px}.pie-chart-skeleton-body__chart{width:150px;height:150px;margin-right:10px}@media(max-width:1279px){.pie-chart-skeleton-body__chart{width:120px;height:120px}}.pie-chart-skeleton-body__level{width:130px;height:20px}", ""]);
// Exports
module.exports = exports;
